import React from 'react'
import { graphql } from 'gatsby'

// Components
import ContactPage from './ContactPage'

const ContactPageIndex = (props) => {
  // console.log('CONTACT PAGE INDEX (template)', props)
  return <ContactPage {...props} />
}

export default ContactPageIndex

export const contactPageQuery = graphql`
  query ContactPageQuery {
    prismicContact {
      data {
        title
        content {
          raw
        }
      }
    }
    ...SiteConfig
  }
`
